module.exports = __webpack_public_path__ + "static/Quick Approval Process Icon-f152c205644257e8bb4d916d881a4f87.svg";